import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { keysTool } from './index';
import { Paper } from '../../pulsechain_components/Paper';
import { TextSelectionBox } from '../../pulsechain_components/TextSelectionBox';
import { Option1 } from './Option1';
import { Option3 } from './Option3';
import { Heading } from '../../pulsechain_components/Heading';

interface Props {
  validatorCount: number | string;
  withdrawalAddress: string;
  os: 'mac' | 'linux' | 'windows';
  chosenTool: keysTool;
  setChosenTool: (tool: keysTool) => void;
}

export const Instructions = ({
  validatorCount,
  withdrawalAddress,
  os,
  chosenTool,
  setChosenTool,
}: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Paper className="mt20" style={{ animation: 'fadeIn 1s' }}>
      <Heading level={2} size="small" color="blueMedium">
        <FormattedMessage defaultMessage="How do you want to generate your keys?" />
      </Heading>
      <div className="my20" style={{ display: 'flex' }}>
        <TextSelectionBox
          isActive={chosenTool === keysTool.CLI}
          onClick={() => setChosenTool(keysTool.CLI)}
          style={{ marginRight: '20px' }}
        >
          {formatMessage({ defaultMessage: 'Download CLI app' })}
        </TextSelectionBox>
        <TextSelectionBox
          isActive={chosenTool === keysTool.CLISOURCE}
          onClick={() => setChosenTool(keysTool.CLISOURCE)}
        >
          {formatMessage({ defaultMessage: 'Build from source' })}
        </TextSelectionBox>
      </div>
      <div>
        {chosenTool === keysTool.CLI && (
          <Option1 {...{ validatorCount, withdrawalAddress, os }} />
        )}
        {chosenTool === keysTool.CLISOURCE && (
          <Option3 {...{ validatorCount, withdrawalAddress, os }} />
        )}
      </div>
    </Paper>
  );
};
